// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ApprovalSummaryHeaderQueryVariables = Types.Exact<{
  currentUserId: Types.Scalars['ID']['input'];
}>;


export type ApprovalSummaryHeaderQuery = { __typename?: 'Query', waitinOnMe?: { __typename?: 'ApprovalPage', approvals: Array<{ __typename?: 'Approval', id: string, dueOn?: Types.Scalars['Date']['input'] | null | undefined, status: { __typename?: 'ApprovalStatusDetail', code: Types.ApprovalStatus, name: string }, approvers: Array<{ __typename?: 'Approver', id: string, status: { __typename?: 'ApproverStatusDetail', code: Types.ApproverStatus, name: string }, user:
          | { __typename?: 'Client', id: string, name: string }
          | { __typename?: 'InternalUser', id: string, name: string }
          | { __typename?: 'TradePartnerUser', id: string, name: string }
         }>, subject:
        | { __typename?: 'Bill' }
        | { __typename?: 'ChangeEvent', id: string, budgetImpactInCents: number }
        | { __typename?: 'ChangeRequest' }
        | { __typename?: 'Invoice' }
       }> } | null | undefined, myApprovals?: { __typename?: 'ApprovalPage', approvals: Array<{ __typename?: 'Approval', id: string, dueOn?: Types.Scalars['Date']['input'] | null | undefined, status: { __typename?: 'ApprovalStatusDetail', code: Types.ApprovalStatus, name: string }, approvers: Array<{ __typename?: 'Approver', id: string, status: { __typename?: 'ApproverStatusDetail', code: Types.ApproverStatus, name: string }, user:
          | { __typename?: 'Client', id: string, name: string }
          | { __typename?: 'InternalUser', id: string, name: string }
          | { __typename?: 'TradePartnerUser', id: string, name: string }
         }>, subject:
        | { __typename?: 'Bill' }
        | { __typename?: 'ChangeEvent', id: string, budgetImpactInCents: number }
        | { __typename?: 'ChangeRequest' }
        | { __typename?: 'Invoice' }
       }> } | null | undefined };

export type PersonalDashboardHeader_ApprovalFragment = { __typename?: 'Approval', id: string, dueOn?: Types.Scalars['Date']['input'] | null | undefined, status: { __typename?: 'ApprovalStatusDetail', code: Types.ApprovalStatus, name: string }, approvers: Array<{ __typename?: 'Approver', id: string, status: { __typename?: 'ApproverStatusDetail', code: Types.ApproverStatus, name: string }, user:
      | { __typename?: 'Client', id: string, name: string }
      | { __typename?: 'InternalUser', id: string, name: string }
      | { __typename?: 'TradePartnerUser', id: string, name: string }
     }>, subject:
    | { __typename?: 'Bill' }
    | { __typename?: 'ChangeEvent', id: string, budgetImpactInCents: number }
    | { __typename?: 'ChangeRequest' }
    | { __typename?: 'Invoice' }
   };

export const PersonalDashboardHeader_ApprovalFragmentDoc = gql`
    fragment PersonalDashboardHeader_Approval on Approval {
  id
  status {
    code
    name
  }
  dueOn
  approvers {
    id
    status {
      code
      name
    }
    user {
      ...Named
    }
  }
  subject {
    ... on ChangeEvent {
      id
      budgetImpactInCents
    }
  }
}
    ${NamedFragmentDoc}`;
export const ApprovalSummaryHeaderDocument = gql`
    query ApprovalSummaryHeader($currentUserId: ID!) {
  waitinOnMe: approvals(
    filter: {approvers: {status: ACTION_REQUIRED, user: [$currentUserId]}}
  ) {
    approvals {
      ...PersonalDashboardHeader_Approval
    }
  }
  myApprovals: approvals(
    filter: {requestedBy: [$currentUserId], status: [CHANGES_NEEDED, REQUESTED]}
  ) {
    approvals {
      ...PersonalDashboardHeader_Approval
    }
  }
}
    ${PersonalDashboardHeader_ApprovalFragmentDoc}`;

/**
 * __useApprovalSummaryHeaderQuery__
 *
 * To run a query within a React component, call `useApprovalSummaryHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalSummaryHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalSummaryHeaderQuery({
 *   variables: {
 *      currentUserId: // value for 'currentUserId'
 *   },
 * });
 */
export function useApprovalSummaryHeaderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApprovalSummaryHeaderQuery, ApprovalSummaryHeaderQueryVariables> & ({ variables: ApprovalSummaryHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApprovalSummaryHeaderQuery, ApprovalSummaryHeaderQueryVariables>(ApprovalSummaryHeaderDocument, options);
      }
export function useApprovalSummaryHeaderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApprovalSummaryHeaderQuery, ApprovalSummaryHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApprovalSummaryHeaderQuery, ApprovalSummaryHeaderQueryVariables>(ApprovalSummaryHeaderDocument, options);
        }
// @ts-ignore
export function useApprovalSummaryHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApprovalSummaryHeaderQuery, ApprovalSummaryHeaderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApprovalSummaryHeaderQuery, ApprovalSummaryHeaderQueryVariables>;
export function useApprovalSummaryHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApprovalSummaryHeaderQuery, ApprovalSummaryHeaderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApprovalSummaryHeaderQuery | undefined, ApprovalSummaryHeaderQueryVariables>;
export function useApprovalSummaryHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApprovalSummaryHeaderQuery, ApprovalSummaryHeaderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApprovalSummaryHeaderQuery, ApprovalSummaryHeaderQueryVariables>(ApprovalSummaryHeaderDocument, options);
        }
export type ApprovalSummaryHeaderQueryHookResult = ReturnType<typeof useApprovalSummaryHeaderQuery>;
export type ApprovalSummaryHeaderLazyQueryHookResult = ReturnType<typeof useApprovalSummaryHeaderLazyQuery>;
export type ApprovalSummaryHeaderSuspenseQueryHookResult = ReturnType<typeof useApprovalSummaryHeaderSuspenseQuery>;
export type ApprovalSummaryHeaderQueryResult = Apollo.QueryResult<ApprovalSummaryHeaderQuery, ApprovalSummaryHeaderQueryVariables>;